<template>
<!-- 欢迎首页 -->
<div class="container">
  <div class="content-wrap">
    <div class="left-col">
      <img src="../../assets/img/hyy.png" style="width: 60%;"/>
    </div>
    <div v-if="showRightColumn" class="right-col hidden">
      <el-form class="findform">
        <el-form-item label="" style="display:flex;width: 90%; margin-top: 5px;">
          <el-select v-model="bbid" filterable placeholder="请选择店铺" @change="changeHyydp" style="width: 100%;">
            <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="width: 160px;margin: 5px auto;">
        <div style="margin-bottom: 10px;">
          <div class="dpygm">
            <div style="background: #FFA936;">店铺码</div>
            <el-button type="primary" @click="xiazai()" style="background: #FFF4E6;color: #FFA936;">下载 <img src="../../assets/img/dpxz.png" style="width: 14px;margin-top: -2px;"/></el-button>
          </div>
          <el-image :src="showImageUrl" @click="handleClickItem" :preview-src-list="[showImageUrl]" style="width: 160px;"/>
        </div>
        <div class="dpygm">
          <div style="background: #1C83FF;">员工码</div>
          <el-button type="primary" @click="xiazaiYg()" style="background: #E5F1FF;color: #1C83FF;">下载 <img src="../../assets/img/ygxz.png" style="width: 14px;margin-top: -2px;"/></el-button>
        </div>
        <el-image :src="staffQRCode" @click="handleClickItem" :preview-src-list="[staffQRCode]" style="width: 160px;"/>
      </div>
      <img src="../../assets/img/czsc.png" class="czscImg" @click="handleczsc"/>
    </div>
    <img src="../../assets/img/czsc2.png" class="czscfixed" @click="handleczsc" v-show="!showRightColumn"/>
  </div>
</div>
</template>
<script>
import { getOssFile, userIdentity } from '../../api/newOss';
import { shopQRCode } from "../../api/attractInvestment";
export default {
  data() {
    return {
      showRightColumn: true, // 控制右侧div的显示隐藏，默认显示
      bbid:'',  //店铺id
      options1: [],
      showImageUrl: '', // 店铺码
      staffQRCode: '', // 员工码
    };
  },
  methods: {
    /* oss 直传图片 */
    handleOss(){
      let obj = { type: 11 };
      getOssFile(obj).then(data => {
        if (data.resultCode == 1) {
          let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
          let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
          let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
          let ossfile = data.resultObj.directory; // 保存路径
          let ossbucket = data.resultObj.bucket; // bucket
          localStorage.setItem('keyossId',ossId);
          localStorage.setItem('keyossSecret',ossSecret);
          localStorage.setItem('keyossHost',ossHost);
          localStorage.setItem('keyossfile',ossfile);
          localStorage.setItem('keyossbucket',ossbucket);
        }
      })
    },
    // 操作手册
    handleczsc(){
      // alert('操作手册');
      window.open('https://www.zhenhuizhuang.cn:8081/useinfo.pdf');
    },
    // 选择店铺
    changeHyydp(val){
      this.options1.filter(item => {
        if(item.id == val){
          console.log(item,'item, 选择当前店铺')
          this.bbid = item.id; // 店铺id
          // this.typeName = item.Name; // 获取对应name
          this.shopQRCode(); // 店铺推广码
        }
      })
    },
    // 初始化查店铺
    getshop(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.options1 = data.resultObj;
            if(data.resultObj.length>1){
              this.bbid = data.resultObj[0].id; // 店铺id
              this.shopQRCode(); // 店铺推广码
            } else { // 默认选中第一个店铺
              this.bbid = data.resultObj[0].id; // 店铺id
              this.shopQRCode(); // 店铺推广码
            }
          }else{
            this.bbid='';
            this.showRightColumn=false;
          }
        }else{
          this.bbid='';
          this.showRightColumn=false;
        }
      })
    },
    // 获取店铺码
    shopQRCode(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
        bbid: this.bbid
      };
      shopQRCode(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.showImageUrl = data.resultObj.qrCode; // 店铺
            this.staffQRCode = data.resultObj.staffQRCode; // 员工
          }
        }
      })
    },
    // 下载店铺码
    xiazai() {
      let address = this.showImageUrl;
      let intercept = this.showImageUrl.split("/")[5].split("?")[0];
      this.downloadImage(address, intercept);
    },
    // 下载员工二维码
    xiazaiYg() {
      let address = this.staffQRCode;
      let intercept = this.staffQRCode.split("/")[5].split("?")[0];
      this.downloadImage(address, intercept);
    },
    /**
     * 根据图片路径下载图片
     * @param imgsrc 图片地址
     * @param name 保存的图片名
     */
     downloadImage(imgSrc, name) {
      var image = new Image();
      // 解决跨域 Canvas 污染问题,
      image.setAttribute("crossorigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); // 将图片格式转为base64
        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "myPhoto"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgSrc + '?time=' + Date.now();  // 注意，这里是灵魂，否则依旧会产生跨域问题
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
  },
  // mounted() {
  //   console.log('mounted hook')
  //   this.handleOss();
  // },
  created() {
    // console.log('created hook')
    this.handleOss();
    this.getshop(); // 初始化查店铺
  }
};
</script>
<style scoped>
.container {
  background-color: #F5F9FF;
  padding: 10px;
  position: absolute;
  top:30px;
  bottom: 0;
}
.content-wrap {
  display: flex;
  height: calc(100% - 10px);
  gap: 10px;
}
.left-col {
  background: white;
  flex-grow: 1;
  min-width: 70%;
  overflow: auto;
  display: flex; /* 添加这一行以启用 Flexbox 布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  text-align: center;
  border-radius: 10px;
}
.right-col {
  background: white;
  /* flex-basis: 232px; */
  min-width: 200px;
  overflow: auto;
  position: relative;
  border-radius: 10px;
}
/* 新增这部分CSS，当右侧列隐藏时（即showRightColumn为false），让左侧列全屏 */
.right-col.hidden + .left-col {
  flex-basis: 100%;
}

.dpygm{
  display: flex;
  justify-content: space-between;
}
.dpygm div{
  width: 50%;
  height: 31px;
  line-height: 31px;
  text-align: center;
  font-size: 14px;
  color: #fff;
}
.dpygm button{
  width: 50%;
  height: 31px;
  line-height: 0;
  border-radius: 0;
  border: none;
  font-size: 14px;
}

/* 操作手册2 */
.czscImg{
  width: 90%;
  position: absolute;
  bottom: 20px;
  right: 5%;
  cursor: pointer;
}
/* 操作手册1 */
.czscfixed{
  width: 120px;
  height: 120px;
  position: fixed;
  bottom: 20px;
  right: 20px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// welcome.vue?7026997c